import { Alert } from 'react-native';
import { processDataFile } from '@utils/fileProcessingHelpers';
import { SHOW_LOADING_MODAL, HIDE_LOADING_MODAL, SHOW_AUTH_MODAL } from '@reduxLocal/actions/types';

export interface SheetHandlersConfig {
  dispatch: any;
  pendingWorkbook: any;
  pendingFileName: string;
  setShowSheetSelector: (show: boolean) => void;
  setAvailableSheets: (sheets: string[]) => void;
  setPendingWorkbook: (workbook: any) => void;
  setPendingFileName: (fileName: string) => void;
  handleDataFileProcessed: () => void;
}

/**
 * Handle sheet selection for multi-sheet Excel files
 */
export const createHandleSheetSelection = (config: SheetHandlersConfig) => {
  const {
    dispatch,
    pendingWorkbook,
    pendingFileName,
    setShowSheetSelector,
    setAvailableSheets,
    setPendingWorkbook,
    setPendingFileName,
    handleDataFileProcessed,
  } = config;

  return async (sheetName: string) => {
    try {
      dispatch({ type: SHOW_LOADING_MODAL, data: { content: `Processing sheet: ${sheetName}...` } });

      if (!pendingWorkbook) {
        throw new Error('Workbook data not found');
      }

      const dummyFile = {
        name: pendingFileName || 'selected_sheet.xlsx',
        type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
      } as File;

      await processDataFile(dummyFile, dispatch, handleDataFileProcessed, pendingWorkbook, sheetName);

      setShowSheetSelector(false);
      setAvailableSheets([]);
      setPendingWorkbook(null);
      setPendingFileName('');
    } catch (error: any) {
      console.error('Error processing selected sheet:', error);
      dispatch({
        type: SHOW_AUTH_MODAL,
        data: {
          content: `Error processing sheet: ${error.message}`,
          type: 'error',
        },
      });
      dispatch({ type: HIDE_LOADING_MODAL });
      setShowSheetSelector(false);
      setPendingWorkbook(null);
      setPendingFileName('');
    }
  };
};




